import { faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Table } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from "../Common";
import Dialog from '../Dialog';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';
import Tran_data_unlock_request from '../Tran_data_unlock_request';



const Tran_currency_stock = () => {

    const navigate = useNavigate();
    const finStartDate = sessionStorage.getItem("startDate");
    const finEndDate = sessionStorage.getItem("endDate");

    const sid = sessionStorage.getItem('sessionId');
    const allowedLocation = sessionStorage.getItem('branchallowed');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [location, setLocation] = useState({ value: 0, label: "Select" });
    const [selectedValue, setSelectedValue] = useState(null);
    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [showListForm, setShowListForm] = useState(true);
    const [showAddForm, setShowAddForm] = useState(false);
    const [denomination, setDenomination] = useState("");
    const [quantity, setQuantity] = useState("");
    const [rate, setRate] = useState("");
    const [amount, setAmount] = useState("");
    const [locationCode, setLocationCode] = useState("");
    const [stockList, setStockList] = useState([]);
    const [currency, setCurrency] = useState("");
    const [currencyCode, setCurrencyCode] = useState("");
    const [selectedCurrency, setSelectedCurrency] = useState(null);
    const [totalAmount, setTotalAmount] = useState("0");
    const [currencyFile, setCurrencyFile] = useState("");
    const [isImportClicked, setImportClicked] = useState(false);


    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");

    const [viewDate, setViewDate] = useState('');
    const currentDate = new Date();

    const [showEditRequest, setShowEditRequest] = useState(false);
    const [editLogObject, setEditLogObject] = useState({ trantype: "", trannumber: "", location: "", entity_name: "", trandate: "", tdu_status: "" });
    const [usdRate, setUSDRate] = useState("");

    const [unlockRequestType, setUnlockRequestType] = useState("");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setSelectedValue(response);
                response != null && handleChange(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'TRAN_CURRENCY_STOCK'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    var msg = [], i = 0;
    const list = () => {
        if (selectedValue == null) {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (selectedValue === null ? " Please select location." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        }
        else {
            setShowListForm(false)
            const loc = selectedValue.id.split('^');
            setLocationCode(loc[1]);
            setLocation(loc[2]);
            Common.callApi(Common.apiTranCurrencyStocks, [sid, 'listCurrencyStocks', loc[1]], (result) => {
                let resp = JSON.parse(result);
                // setAmount(resp.prd_amount);
                setStockList(resp.resarray);
                setTotalAmount(resp.sumamount)

            });
        }
    }

    const addCurrencyStock = () => {
        if (denomination == "" || quantity == "" || rate == "") {
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (selectedCurrency === null ? " Please select currency." : '');
            msg[i++] = (denomination === "" ? " Please fill denomination." : '');
            msg[i++] = (quantity === "" ? " Please fill quantity." : '');
            msg[i++] = (rate === "" ? " Please fill rate." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            $('.loader').show();
            let curr = selectedCurrency.id.split('^');
            setCurrencyCode(curr[1]);
            setCurrency(curr[2]);
            var usdAmt = 0;
            if (usdRate != "" && usdRate != 0) {
                usdAmt = (rate * quantity * denomination) / usdRate;
            }
            const obj = {
                deno: denomination,
                qty: quantity,
                rate: rate,
                loc: locationCode,
                amt: amount,
                currency: curr[1],
                productType: 'OPNCN',
                product: 'CN',
                usdRate: usdRate == "" ? 0 : usdRate * 1,
                usdAmt: usdAmt
            }
            Common.callApi(Common.apiTranCurrencyStocks, [sid, 'addCurrencyStocks', JSON.stringify(obj)], (result) => {
                let resp = JSON.parse(result);
                if (resp.msg === "1") {
                    $('.loader').hide();
                    setStockList(resp.currStock.resarray);
                    setTotalAmount(resp.currStock.sumamount);
                    setDenomination("");
                    setRate("");
                    setQuantity("");
                    setAmount("");
                    setSelectedCurrency("");
                } else {
                    $('.loader').hide();
                    setMsgBox(true);
                    setMsgText(resp.msg);
                }
            });
            if (unlockRequestType !== "SELF") {
                const object = {
                    srno: 1,
                    type: 'OPNCN',
                    status: 'E',
                    currentDate: Common.dateYMD(currentDate),
                    pageright: 'TRAN_CURRENCY_STOCK'
                }
                Common.callApi(Common.apiUnlockEdit, [sid, 'expireUnlock', JSON.stringify(object)], (result) => {
                    console.log(result);
                });
            }
            // list();
        }
    }


    const uploadFile = () => {
        $('.loader').show();
        if (document.getElementById('importExcel').files[0] === undefined) {
            $('.loader').hide();
            setMsgText("Please select a file to upload.");
            setMsgBox(true);
        } else {
            var tempArray = document.getElementById('importExcel').files[0].name.split('.');
            if (tempArray.length > 2) {
                $('.loader').hide();
                setMsgText("(.) not allowed in file name.");
                setMsgBox(true);
            } else if (document.getElementById('importExcel').files[0].size > 10 * 1024 * 1024) {  // 10 MB
                $('.loader').hide();
                setMsgText("Please select a file with in 10 MB size.");
                setMsgBox(true);
            } else if (tempArray[1] != 'xlsx') {
                $('.loader').hide();
                setMsgText("File extension should be in xlsx format");
                setMsgBox(true);
            }
            else {
                const obj = {
                    loc: locationCode,
                    srno: 8888,
                    uploadType: "uploadCurrency",
                    pageright: "TRAN_OPN_CN_IMPORT",
                    sid: sid,
                    currencyFile: currencyFile,
                    loc: locationCode,
                    allowedLocation: allowedLocation.split(',')
                }
                Common.uploadApi(JSON.stringify(obj), 'importExcel', (result) => {
                    let resp = JSON.parse(result);
                    console.log(resp);
                    $('.loader').hide();
                    if (!(resp.err.trim())) {
                        setStockList(resp.docdetail.resarray);
                        setTotalAmount(resp.docdetail.sumamount);
                        setMsgText(`<p className='text-success'>${resp.msg}</p>`)
                        console.log(resp.msg);
                        setMsgBox(true);
                    } else {
                        setMsgText(`<p className='text-danger'>${resp.err}</p>`);
                        setMsgBox(true);
                    }
                });
            }
        }
    }

    const calculateAmount = (deno, qty, rate) => {
        let number = deno * qty * rate;
        var roundedNumber = parseFloat(number.toFixed(2));

        setAmount(roundedNumber);
    }

    const handleDeno = (e) => {

        Common.validateDecValue(e.target.value, setDenomination)

        // setDenomination(e.target.value);

        calculateAmount(e.target.value, quantity, rate);
    }

    const handleQuantity = (e) => {
        Common.validateNumValue(e.target.value, setQuantity)

        // setQuantity(e.target.value);
        calculateAmount(denomination, e.target.value, rate)
    }

    const handleRate = (e) => {
        Common.validateDecValue(e.target.value, setRate)

        // setRate(e.target.value);
        calculateAmount(denomination, quantity, e.target.value)

    }

    const handleChange = value => {
        setSelectedValue(value);
        var id = value.id;
        var location = id.split("^");
        sessionStorage.activeBranch = location[1];
    }

    const handleCurrencyChange = value => {
        const a = value.id.split("^");
        const obj = {
            isd: a[1],
            location: locationCode,
            product: "CN"
        }
        Common.callApi(Common.apiMasterIBR, [sid, "getrate", JSON.stringify(obj)], result => {
            let resp = JSON.parse(result);
            //setPRate(resp.buyrate * 1);
            //setMaxPRate(resp.maxbuyrate * 1);
            //setMinPRate(resp.minbuyrate * 1);
            setUSDRate(resp.usdratebuy * 1);
        });
        setSelectedCurrency(value);
    }


    const handleBack = () => {
        if (showAddForm) {
            setShowAddForm(false);
        } else if (isImportClicked) {
            setImportClicked(false);
        }
        else {
            setShowListForm(true);
        }
    }



    const handleDelete = (res) => {
        const obj = {
            id: res.line,
            isd: res.prd_isd
        }
        $(".loader").show();
        Common.callApi(Common.apiTranCurrencyStocks, [sid, 'deleteCurrencyStock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            $(".loader").hide();
            if (resp.msg !== "") {
                setMsgBox(true);
                setMsgText(resp.msg);
            } else {
                setStockList(resp.optrial.resarray);
                setTotalAmount(resp.optrial.sumamount);
            }
        });
    }

    const handleexcel = () => {
        setShowListForm(false)
        const loc = selectedValue.id.split('^');
        console.log(selectedValue);
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        Common.callDownloadApiPost(Common.apiTranCurrencyStocks, "post", [sid, 'downloadexcel', loc[1]]);
    }

    const handleImport = () => {
        setShowAddForm(false);
        setImportClicked(true);
    }

    const handleAddBtn = () => {
        setShowAddForm(true);
        setImportClicked(false);

    }

    function downloadFormatList() {
        var object1 = {
            srno: 23,
            pageright: 'TRAN_OPN_CN_IMPORT',
            downloadType: "downloadFormat",
        }
        Common.callDownloadApiPost(Common.apiFormat, "post", [sid, 'downloadFormat', JSON.stringify(object1)]);
    }



    const btnEditRequest = () => {
        const currDate = new Date();
        const newDate = finStartDate
        // .split('/');

        // const newViewDate = newDate[2] + '-' + newDate[1] + '-' + newDate[0]
        const newCurrDate = Common.dateYMD(currDate);

        const dateA = new Date(newDate);
        const dateB = new Date(newCurrDate);

        // Calculate the difference in milliseconds
        const differenceInMilliseconds = dateB - dateA;

        // Convert milliseconds difference to days
        const differenceInDays = Math.ceil(differenceInMilliseconds / (1000 * 3600 * 24));

        console.log(differenceInDays);

        const obj = {
            srno: 1,
            type: 'OPNCN',
            pageright: 'TRAN_CURRENCY_STOCK',
            location: locationCode
        }
        // const message = 'unlock'
        Common.callApi(Common.apiUnlockEdit, [sid, 'checkUnlock', JSON.stringify(obj)], (result) => {
            let resp = JSON.parse(result);
            setUnlockRequestType(resp.requestsrc);
            if (Common.editDateLimit == differenceInDays || resp.msg == "unlock") {
                setShowAddForm(true);
                setImportClicked(false);
            } else {
                //console.log("----else");
                Common.callApi(Common.apiUnlockEdit, [sid, 'getStatus', JSON.stringify(obj)], (result) => {
                    let res = JSON.parse(result);
                    setEditLogObject({ trantype: 'OPNCN', trannumber: 1, location: locationCode, entity_name: location, tranDate: Common.dateYMD(currDate), tdu_status: res });
                    setShowEditRequest(true);
                });
            }
        })


    }

    function closeModel() {
        setCurrencyFile("")
        setMsgBox(false)
    }

    return (
        <div>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h2>Currency Stock</h2>
                    </Col>
                </Row>
                &nbsp;
                {
                    showListForm ? <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions={false}
                                        defaultOptions={false}
                                        value={selectedValue}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        loadOptions={Picklist.fetchLocationAllowedPicklist}
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleChange}
                                        isDisabled={branchDisable === "true"}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col >
                                {
                                    userRight.query === "1" ?
                                        <>
                                            <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => list()} >List</Button>&nbsp;


                                            <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={downloadFormatList}>Download Format</Button>&nbsp;
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={handleImport}>Import</Button>&nbsp;

                                        </>
                                        : null}
                            </Col>
                        </Row>
                        &nbsp;
                    </> : <>
                        <Row>
                            <Col className='col-md-3 col-6'>
                                <Form.Label>Location : {location}</Form.Label>
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col>
                                <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleBack}>Back</Button>{' '}
                                {
                                    userRight.add === "1" && !showAddForm
                                        ?
                                        <>
                                            <Button variant='outline-success' className='buttonStyle' size='sm'
                                                onClick={btnEditRequest}
                                            >Edit</Button>
                                        </>
                                        : null
                                }&nbsp;
                                <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={handleexcel}>Download</Button>{' '}
                                {/* {
                                    (!isImportClicked && !showListForm) &&
                                    <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={handleImport}>Import</Button>
                                } */}
                            </Col>
                        </Row>
                        &nbsp;
                    </>
                }

                {isImportClicked &&
                    <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group controlId="importExcel">
                                <Form.Label>Choose File<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="file" value={currencyFile} onChange={e => setCurrencyFile(e.target.value)} />
                            </Form.Group>
                        </Col>&nbsp;
                        <Col >
                            <Button variant="outline-success" className='buttonStyle' size='sm' onClick={() => uploadFile()}>Submit</Button>{' '}
                            {/* <Button variant="outline-danger" className="btn_admin" onClick={() => setImportClicked(false)}>Back</Button> */}
                        </Col>&nbsp;
                    </>
                }

                {
                    showAddForm && <>
                        <Row>

                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Currency<span className="text-danger">*</span></Form.Label>
                                    <AsyncSelect
                                        cacheOptions
                                        defaultOptions
                                        value={selectedCurrency}
                                        getOptionLabel={e => e.label + ' '}
                                        getOptionValue={e => e.id}
                                        // loadOptions={Picklist.fetchLocationAllowedPicklist}
                                        loadOptions={(search) => Picklist.fetchCurrencyAllowedPicklist(search, 'CN')} // location = 1 , 2
                                        onInputChange={Picklist.handleInputChange}
                                        onChange={handleCurrencyChange}
                                    >
                                    </AsyncSelect>
                                </Form.Group>
                            </Col>

                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Denomination<span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        value={denomination} onChange={(e) => handleDeno(e)}
                                        placeholder="Denomination"
                                        maxLength={Common.maximumLength}
                                    />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Quantity<span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        value={quantity} onChange={(e) => handleQuantity(e)}
                                        maxLength={Common.maximumLength}
                                        placeholder="Quantity" />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Rate<span className="text-danger">*</span></Form.Label>
                                    <Form.Control
                                        value={rate} onChange={(e) => handleRate(e)}   //e => setRate(e.target.value)}
                                        maxLength={Common.rateMaxLength}
                                        placeholder="Rate" />
                                </Form.Group>
                            </Col>
                            <Col className='col-md-3 col-6'>
                                <Form.Group>
                                    <Form.Label>Amount</Form.Label>
                                    <Form.Control value={amount} disabled
                                        maxLength={Common.maximumLength}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        &nbsp;
                        <Row>
                            <Col>
                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={addCurrencyStock} >Add</Button>{' '}
                            </Col>
                        </Row>
                        &nbsp;
                    </>

                }
                {
                    !showListForm &&
                    <Row>
                        <Col>
                            <Table responsive striped bordered hover>
                                <thead>
                                    {
                                        totalAmount != '0' &&
                                        <tr>
                                            <td colSpan={7}></td>
                                            <td style={{ textAlign: 'right' }} colSpan={2}><b>Total Amount:</b> <span>{totalAmount}</span></td>
                                        </tr>
                                    }

                                    <tr>
                                        {userRight.edit === "1" && showAddForm ? <th></th> : null}
                                        <th>ISD</th>
                                        <th style={{ textAlign: 'right' }}>Denomination</th>
                                        <th style={{ textAlign: 'right' }}>Quantity</th>
                                        <th style={{ textAlign: 'right' }}>Rate</th>
                                        <th style={{ textAlign: 'right' }}>Amount</th>
                                        <th style={{ textAlign: 'right' }}>USD Rate</th>
                                        <th style={{ textAlign: 'right' }}>USD Amount</th>
                                        {/* <th>Total amount</th> */}
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        stockList.map((res) =>
                                            <tr key={res.prd_line_no}>
                                                {userRight.delete === "1" && showAddForm ?
                                                    <td className="textCenter" >
                                                        <span className="handCursor" onClick={() => handleDelete(res)} >
                                                            <div className="colorThemeBlue"><FontAwesomeIcon icon={faTrash} /></div>
                                                        </span>
                                                    </td>
                                                    : null
                                                }
                                                <td>{res.prd_isd}</td>
                                                <td style={{ textAlign: 'right' }}>{res.prd_deno}</td>
                                                <td style={{ textAlign: 'right' }}>{res.prd_qty}</td>
                                                <td style={{ textAlign: 'right' }}>{res.prd_rate}</td>
                                                <td style={{ textAlign: 'right' }}>{res.prd_amount}</td>
                                                <td>{res.prd_usd_rate}</td>
                                                <td>{res.prd_usd_amount}</td>
                                                {/* <td>{totalAmount}</td> */}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                }

            </Container>

            <div>
                <Dialog isOpen={isMsgBox} onClose={closeModel}>
                    {msgText}
                </Dialog>
                <Tran_data_unlock_request logObject={editLogObject} show={showEditRequest} hdrNotExist={true} onHide={() => setShowEditRequest(false)} />
            </div>
        </div>
    )
}

export default Tran_currency_stock
